import React from 'react';
import Immutable from 'immutable';
import { Block } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import type { ParagraphPriceCalculator } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

const PriceCalculator = ({ entity }: { entity: ImmutableEntity<ParagraphPriceCalculator> }) => {
  const paragraph = entity.toJS();

  const title = paragraph.field_title[0]?.value;
  const body = paragraph.field_body[0]?.processed;
  const productPriceBlockEntity = paragraph.field_product_price_calc_block[0].entity;

  return (
    <Container className="Paragraph ParagraphPriceCalculatorBlock">
      {(title && body) && (
        <div className="row">
          <div className="col-12 col-lg-6 offset-lg-2">
            {title && (
              <h3 className="PriceCalculatorBlockParagraph__title">{title}</h3>
            )}
            {body && (
              <WysiwygField className="PriceCalculatorBlockParagraph__body" html={body} />
            )}
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-12 col-lg-8 offset-lg-2">
          <Block entity={Immutable.fromJS(productPriceBlockEntity)} />
        </div>
      </div>
    </Container>
  );
};

export default PriceCalculator;
